import { render, staticRenderFns } from "./publicizeList.vue?vue&type=template&id=2cf3ac31&scoped=true"
import script from "./publicizeList.vue?vue&type=script&lang=js"
export * from "./publicizeList.vue?vue&type=script&lang=js"
import style0 from "./publicizeList.vue?vue&type=style&index=0&id=2cf3ac31&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf3ac31",
  null
  
)

export default component.exports